import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const InfoContentView = ({
  integrationData,
  location,
  setSettingBackPath,
  history,
}) => {
  const theme = useTheme();

  const handleLocationSettings = () => {
    setSettingBackPath(location.pathname + location.search + location.hash);
    history.replace("/setting#location");
  };

  // Common Paper styling that automatically adapts to theme
  const paperStyle = {
    p: 2,
    bgcolor: "background.paper",
    borderRadius: 1,
  };

  const infoContent = {
    "basic.automation": (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper elevation={0} sx={paperStyle}>
          <Typography variant="body1" gutterBottom>
            System default integration. It can provide automation status and
            control the automations.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" color="text.secondary">
              {"• Immediately run a task-flow automation"}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Enable / disable a recurring automation"}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Check automation running status"}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Check automation enable / disable status"}
            </Typography>
          </Box>
        </Paper>
      </Box>
    ),
    "basic.ui": (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper elevation={0} sx={paperStyle}>
          <Typography variant="body1" gutterBottom>
            System default integration. It provides capabilities related to the
            App UI and the dashboard.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" color="text.secondary">
              {"• Send App notification"}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Change UI dashboard widget value"}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Read UI dashboard widget status"}
            </Typography>
          </Box>
        </Paper>
      </Box>
    ),
    "basic.time": (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper elevation={0} sx={paperStyle}>
          <Typography variant="body1" gutterBottom>
            This integration provides all time related capabilities. It&apos;s
            automatically managed based on your Location settings.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" color="text.secondary">
              {"• Auto-installed when Location 'Home' is configured"}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Auto-uninstalled when Location 'Home' is not set"}
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLocationSettings}
            sx={{ mt: 2, boxShadow: "none", textTransform: "none" }}
          >
            Location Settings
          </Button>
        </Paper>
      </Box>
    ),
    "basic.phone": (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper elevation={0} sx={paperStyle}>
          <Typography variant="body1">
            On your mHome Android App (available soon) & iOS App (available
            later), go to &quot;Menu -&gt; Phone Setting &quot; to connect your
            phone and grant the access.
          </Typography>
        </Paper>
      </Box>
    ),
    "basic.chat": (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper elevation={0} sx={paperStyle}>
          <Typography variant="body1" gutterBottom>
            Default integration for chat. Supported capabilities:
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" color="text.secondary">
              {
                "• Define a Wake-Word as automation trigger, like 'When I say \"good night\", turn off bedroom lights.'"
              }
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {
                "• Ask the assistant to reply a message in the current chat, like 'When I say \"time\", reply the current time in the chat'. Notice, currently the assistant is not allowed to initiate a message in the chat. It can only reply to your requests or wake-words."
              }
            </Typography>
          </Box>
        </Paper>
      </Box>
    ),
    "basic.weather": (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper elevation={0} sx={paperStyle}>
          <Typography variant="body1" gutterBottom>
            Provide weather data. Adding home location can help our agent better
            generate the automation. And select your weather data provider to
            start.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" color="text.secondary">
              {"• Auto-installed when one provider is connected."}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Auto-uninstalled when no provider is connected."}
            </Typography>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLocationSettings}
            sx={{ mt: 2 }}
          >
            Location Settings
          </Button>
        </Paper>
      </Box>
    ),
    "basic.device": (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Paper elevation={0} sx={paperStyle}>
          <Typography variant="body1" gutterBottom>
            Connect any device providers to get started.
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body1" color="text.secondary">
              {"• Auto-installed when any provide is connected."}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {"• Auto-uninstalled when no available provider connections."}
            </Typography>
          </Box>
        </Paper>
      </Box>
    ),
  };

  return infoContent[integrationData.integration] || null;
};

export default InfoContentView;
